import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/quotation';

export type Products = Awaited<ReturnType<(typeof service)['getProducts']>>;

export function getProductsOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Products>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['products', [guid], [search]],
    queryFn: async () => await service.getProducts(guid),
    initialData,
  });
}
